export enum SortTypes {
  ID = 'ID',
  NAME = 'Name',
  STUDIO = 'Studio',
  DURATION = 'Duration',
}

export enum ImagesVariable {
  Banner,
  Logo,
}
